// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationProviderDetails {
    static getAttributeTypeMap() {
        return ClaimAdjudicationProviderDetails.attributeTypeMap;
    }
}
ClaimAdjudicationProviderDetails.discriminator = undefined;
ClaimAdjudicationProviderDetails.additionalProperties = false;
ClaimAdjudicationProviderDetails.attributeTypeMap = [
    {
        "name": "providerName",
        "baseName": "providerName",
        "type": "string"
    },
    {
        "name": "providerAddress1",
        "baseName": "providerAddress1",
        "type": "string"
    },
    {
        "name": "providerAddress2",
        "baseName": "providerAddress2",
        "type": "string"
    },
    {
        "name": "providerCity",
        "baseName": "providerCity",
        "type": "string"
    },
    {
        "name": "providerState",
        "baseName": "providerState",
        "type": "string"
    },
    {
        "name": "providerZipCode",
        "baseName": "providerZipCode",
        "type": "string"
    },
    {
        "name": "providerFederalEin",
        "baseName": "providerFederalEin",
        "type": "string"
    },
    {
        "name": "providerFax",
        "baseName": "providerFax",
        "type": "string"
    },
];
//# sourceMappingURL=claimAdjudicationProviderDetails.js.map